import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const getUserData = async () => {
  try {
    const token = getAuthToken();
    const response = await api.get("/user/profile", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("User Data", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getUserDataById = async (userId) => {
  try {
    const token = getAuthToken();
    const response = await api.get(`/user/profile/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateUserData = async (data) => {
  try {
    // console.log("updated data: ", data);
    const token = getAuthToken();
    const response = await api.put("/user/profile", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
const passwordReset = async (currentPassword, newPassword) => {
  // console.log(currentPassword, newPassword);
  try {
    const token = getAuthToken();
    const data = await api.put(
      "/user/password-reset",
      {
        currentPassword,
        newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (err) {
    // console.log(err);
    throw err;
  }
};
/**
 * Update user profile by ID (Legacy route)
 * @param {string} userId - User ID
 * @param {Object} data - User data to update
 * @param {string} [data.name] - User's name
 * @param {string} [data.email] - User's email
 * @param {string} [data.password] - New password
 * @param {string} [data.address] - User's address
 * @param {number} [data.isDeleted] - Deletion status (0 or 1)
 * @returns {Promise<Object>} Updated user data
 */
const updateUserDataById = async (userId, data) => {
  try {
    const token = getAuthToken();
    const response = await api.put(`/user/profile/${userId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get current user's purchase history
 * @returns {Promise<Array>} Array of orders
 */
const getUserPurchaseHistory = async () => {
  try {
    const token = getAuthToken();
    const response = await api.get("/user/orders", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user's purchase history by ID (Legacy route)
 * @param {string} userId - User ID
 * @returns {Promise<Array>} Array of orders
 */
const getUserPurchaseHistoryById = async (userId) => {
  try {
    const token = getAuthToken();
    const response = await api.get(`/user/orders/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user's FCM token
 * @param {string} [type] - Token type ('admin' for admin tokens)
 * @returns {Promise<Object>} Token response { token: string }
 */
// const getUserToken = async (type = null) => {
//   try {
//     const token = getAuthToken();
//     const config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     // Add query parameter for admin token retrieval
//     if (type === "admin") {
//       config.params = { type: "admin" };
//     }

//     const response = await api.get("/user/token", config);
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

/**
 * Update user's FCM token
 * @param {Object} data - Token data
 * @param {string} data.token - FCM token
 * @returns {Promise<Object>} Success message
 */
// const updateUserToken = async (data) => {
//   try {
//     const token = getAuthToken();
//     const response = await api.put("/user/token", data, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

/**
 * Delete current user account (soft delete)
 * @returns {Promise<Object>} Deleted user data
 */
const deleteUser = async () => {
  try {
    const token = getAuthToken();
    const response = await api.post(
      "/user/delete",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete user account by ID (Legacy route - soft delete)
 * @param {string} userId - User ID
 * @returns {Promise<Object>} Deleted user data
 */
const deleteUserById = async (userId) => {
  try {
    const token = getAuthToken();
    const response = await api.post(
      `/user/delete/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Add or update current user's address
 * @param {Object} data - Address data
 * @param {string} data.address - User's address
 * @returns {Promise<Object>} Updated user data
 */
const addUserAddress = async (data) => {
  try {
    const token = getAuthToken();
    const response = await api.post("/user/address", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Add or update user's address by ID (Legacy route)
 * @param {string} userId - User ID
 * @param {Object} data - Address data
 * @param {string} data.address - User's address
 * @returns {Promise<Object>} Updated user data
 */
const addUserAddressById = async (userId, data) => {
  try {
    const token = getAuthToken();
    const response = await api.post(`/user/address/${userId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Add order to user's purchase history
 * @param {Object} orderData - Order data
 * @param {Object} orderData.order - Order object with products and transaction details
 * @returns {Promise<Object>} Updated user data
 */
const addOrderToUser = async (orderData) => {
  try {
    const token = getAuthToken();
    const response = await api.post("/user/order-history", orderData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const resetForgetPassword = async (idToken, newPassword) => {
  try {
    await api.post("/forgot-password", {
      idToken,
      newPassword,
    });
  } catch (err) {
    throw err;
  }
};

/**
 * Get admin FCM tokens (admin only)
 * @returns {Promise<Object>} Token response { token: string }
 */
// const getAdminToken = async () => {
//   return getUserToken("admin");
// };

export {
  // Profile management
  getUserData,
  getUserDataById,
  updateUserData,
  updateUserDataById,
  passwordReset,

  // Purchase history
  getUserPurchaseHistory,
  getUserPurchaseHistoryById,
  addOrderToUser,

  // FCM token management
  // getUserToken,
  // updateUserToken,
  // getAdminToken,

  // User management
  deleteUser,
  deleteUserById,

  // Address management
  addUserAddress,
  addUserAddressById,

  // FORGOT RESET PASSWORD
  resetForgetPassword,
};
